import React, { useCallback, useState } from "react";
import styles from "../../../home/GraphContainer/styles.module.scss";
import CommonFilter from "../../../../../atoms/CommonFilter";
import DateRangePickerShortCuts from "../../../../../organisms/dateRangePicker";
import {
  addHours,
  startOfDay,

  subDays
} from "rsuite/esm/internals/utils/date";
import TimeReportChart from "./TimeReportChart";
import {
  getEmployeeList,
  getAllProjects,
  getTeamsList,
  getBusinessSegmentList,
} from "../../../../../../services/basicGets";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { getData } from "../../../../../../services";
import { useSelector } from "react-redux";

const OverviewContainer = ({information, type,id}) => {

  const [cookies] = useCookies(["e_t"]);
  const defaultToday = new Date();
  const [projects, setProjects] = useState([]);
  const [teams, setTeams] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [BusinessSegment, setBusinessSegment] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filters, setFilters] = useState({});
  // const [date, setDate] = useState({
  //   start_date: addHours(startOfDay(startOfMonth(defaultToday)), 12),
  //   end_date: addHours(startOfDay(endOfMonth(defaultToday)), 12),
  // });

  const [date, setDate] = useState({
    start_date: addHours(startOfDay(subDays(defaultToday, 14)), 12), // 14 days ago
    end_date: addHours(startOfDay(defaultToday), 12), // Today
  });

  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  useEffect(() => {
    (async () => {
      const emp = await getEmployeeList({
        params: {
          ...(!isAdmin && { employee_id: cookies.euid }), 
        },
        token: cookies.e_t,
      });
      // const teamRoles = await getTeamsList({
      //   token: cookies.e_t,
      // });
      // setTeams(teamRoles);
      const teamProjects = await getAllProjects({
        params: {
          ...(!isAdmin && { employee_id: cookies.euid }), 
        },
        token: cookies.e_t,
      });

      const BusinessSegmentRoles = await getBusinessSegmentList({
              token: cookies.e_t,
            });

      const allTeams = await getTeamsList({
        params: {
          ...(!isAdmin && { employee_id: cookies.euid }), 
        },
        token: cookies.e_t,
      });

      setBusinessSegment(BusinessSegmentRoles?.data);
      setProjects(teamProjects?.data);
      setEmployees(emp?.employeeResponseValueLabel);
      setTeams(allTeams?.data?.teams);
    })();
  }, []);

  const filterOptions = [
    // {
    //   id: "project",
    //   label: "Project",
    //   type: "multi-select",
    //   options: projects,
    // },
    {
      id: "team",
      label: "Team",
      type: "multi-select",
      options: teams,
    },

    {
      id: "employee",
      label: "Employee",
      type: "multi-select",
      options: employees,
    },
    {
      id: "business_segment",
      label: "Business Segment",
      type: "multi-select",
      options: BusinessSegment,
      customStyles : {minWidth : '165px'},
    }
  ];


  const getDashboardGraphData = useCallback(async () => {
    try {
      const res = await getData({
        endpoint: "Dashboard/getTaskTimerDashboardGraph",
        params: {
          // search_query: searchedValue,
          // page: currentPage,
          // page_limit: itemsPerPage,
          // business_id: cookies.bid,
          start_date: date?.start_date,
          end_date : date?.end_date,
          project_ids: `[${JSON.stringify(id)}]`,
          employee_ids : JSON.stringify(filters?.employee),
          team_ids : JSON.stringify(filters?.team),
          employee_id: isAdmin ? null  : cookies.euid , 
          businessSegment : JSON.stringify(filters?.business_segment),
        },

        token: cookies.e_t,
      });
      if (res) {
        setTableData(res);
      }
    } catch (error) {
      console.error(error); // Use console.error for errors
    }
  }, [cookies.e_t, filters, date]);

  useEffect(() => {
    getDashboardGraphData();
  }, [getDashboardGraphData]);




  return (
    <div className={styles.graph_container}>
      <div className="d-flex justify-content-between">
        <CommonFilter
          filters={filterOptions}
          onFilterChange={handleFilterChange}
        />

        <DateRangePickerShortCuts setDate={setDate} />

      </div>

      <TimeReportChart categorydata={tableData?.category} data={tableData?.chart_data?.[0]?.data} />
    </div>
  );
};

export default OverviewContainer;
